export default "__VITE_ASSET__DEQqK3Uw__"